import React from 'react'

import indexedTitleStyles from "./IndexedTitle.module.css"

export default function IndexedTitle({ children, index }) {
    //console.log("children: ", children)
    return(       
        <h2 className={indexedTitleStyles.title}>
            <span className={indexedTitleStyles.number}>{index}</span>
            {children}
        </h2>
    )
}